import { graphql } from './graphql';

export const ellipsesIconFragment = graphql(`
  fragment EllipsisIcon on EllipsisIcon {
    __typename
    title
    key
    iconName
  }
`);
